import {Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {OperationFonction} from '../../../constantes/operations-fonctions.constantes';
import {FonctionLogicielle} from '../../../constantes/fonctions-logicielle-constantes';
import {UtilisateurCourantService} from '../../../services/utilisateurs/utilisateur-courant.service';
import {AutorisationAggregate} from '../../../aggregats/autorisation/autorisation.aggregate';
import {Subscription} from 'rxjs';

export abstract class IfAuthorizedAbstractDirective {
  private _operation: OperationFonction = null;
  private _fonctionLogicielle: FonctionLogicielle = null;

  private _elseTemplate: TemplateRef<any> = null;

  private subs: Subscription[] = [];

  protected forEdition() {
    this._operation = OperationFonction.Edition;
    this.updateVisibility();
  }

  protected forVisualisation() {
    this._operation = OperationFonction.Visualisation;
    this.updateVisibility();
  }

  protected forSuppression() {
    this._operation = OperationFonction.Suppression;
    this.updateVisibility();
  }

  protected forExport() {
    this._operation = OperationFonction.Export;
    this.updateVisibility();
  }

  protected forActif() {
    this._operation = OperationFonction.Actif;
    this.updateVisibility();
  }

  protected set elseTemplate(elseTemplate){
    this._elseTemplate = elseTemplate;
    this.updateVisibility();
  }

  protected set fonctionLogicielle(value: string | number) {
    if (value != null) {
      let fonction: string = null;
      if (typeof value == 'string') {
        fonction = Object.keys(FonctionLogicielle).find(it => it.toLocaleLowerCase() == value.toLocaleLowerCase());
        this._fonctionLogicielle = FonctionLogicielle[fonction];
      } else {
        this._fonctionLogicielle = Number(value) as FonctionLogicielle;
      }
      if (this._fonctionLogicielle != null) {
        this.updateVisibility();
      } else {
        throw new Error(`La fonction logicielle ${value} n’existe pas !`);
      }
    }
  }

  protected unsubscribeAll() {
    this.subs.forEach(it => it.unsubscribe());
    this.subs = [];
  }

  private updateVisibility() {
    this.viewContainerRef.clear();
    if (this._fonctionLogicielle != null && this._operation != null) {
      const autorizationAggregate = new AutorisationAggregate(this._fonctionLogicielle, this._operation);
      this.subs.push(
        this.utilisateurCourantService.isAuthorized(autorizationAggregate).subscribe(autorized => {
          if (autorized) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
          } else {
            if (this._elseTemplate != null) {
              this.viewContainerRef.createEmbeddedView(this._elseTemplate);
            } else {
              this.viewContainerRef.clear();
            }
          }
        }),
      );
    }
  }

  protected constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private utilisateurCourantService: UtilisateurCourantService,
  ) {}
}
